import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { DateTime } from '@mews/framework';
import { getMonthGroupedOrderItemsTotal } from '../../../../selectors';
import { getDateTimeFromMonth } from '../../../../selectors/groupingHelpers';
import { TotalAmountAndCount } from '../../../../types';

interface StateProps {
    total: TotalAmountAndCount;
    dateTime: DateTime;
}

interface OwnProps {
    billId: string;
    scope: string;
    month: string;
    toggleSelect: () => void;
}

export const connectMonthListLabel = connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        dateTime: (state: ApplicationState, { month }: OwnProps) => getDateTimeFromMonth(state, { month }),
        total: (state: ApplicationState, { month, billId }: OwnProps) =>
            getMonthGroupedOrderItemsTotal(state, { month, billId }),
    })
);
